import {OrgOverviewSidebarNudge, type OrgOverviewSidebarNudgeProps} from './OrgOverviewSidebarNudge'

export type OrgOverviewSidebarNudgePartialProps = OrgOverviewSidebarNudgeProps

export function OrgOverviewSidebarNudgePartial(props: OrgOverviewSidebarNudgePartialProps) {
  return <OrgOverviewSidebarNudge {...props} />
}
